import { useTranslation } from 'react-i18next';

import { Button } from '~/components/Button';
import type {
  TrackReleaseType,
  TrackRoleType,
} from '~/modules/artist-roster/pages/artist-details/utils/types';

import { TrackAppliedFilterListItem } from './TrackAppliedFilterListItem';

interface TrackAppliedFilterListProps {
  releaseType?: TrackReleaseType;
  role?: TrackRoleType;
  onRemoveReleaseType: () => void;
  onRemoveRole: () => void;
  onClear: () => void;
}

export function TrackAppliedFilterList({
  releaseType,
  role,
  onRemoveReleaseType,
  onRemoveRole,
  onClear,
}: TrackAppliedFilterListProps) {
  const { t } = useTranslation('roster');

  return (
    <div
      className="flex items-center gap-md py-md"
      aria-label="Applied filters"
    >
      <div className="text-body-sm">{t('Filter(s) applied:')}</div>
      {releaseType ? (
        <TrackAppliedFilterListItem
          label={t(`filters.releaseType.${releaseType}.label`)}
          onRemove={onRemoveReleaseType}
        />
      ) : null}
      {role ? (
        <TrackAppliedFilterListItem
          label={t(`filters.role.${role}`)}
          onRemove={onRemoveRole}
        />
      ) : null}
      <Button
        variant="text"
        onClick={onClear}
        className="-ml-sm px-sm py-xs text-body-sm font-semibold"
      >
        {t('filters.clearFilters')}
      </Button>
    </div>
  );
}

TrackAppliedFilterList.displayName = 'TrackAppliedFilterList';
